import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { ReactComponent as ArrowRightIcon } from "../../assets/images/arrow-right-line.svg";
import styles from "./Breadcrumb.module.css";

export interface BreadcrumbItem {
    label: string;
    path?: string;
    isActive?: boolean;
}

export interface BreadcrumbStyleClasses {
    nav?: string;
    separator?: string;
    link?: string;
    text?: string;
    active?: string;
}

interface BreadcrumbProps {
    items: BreadcrumbItem[];
    className?: string;
    classes?: BreadcrumbStyleClasses;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = "", classes = {} }) => {
    const navigate = useNavigate();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const handleItemClick = (item: BreadcrumbItem) => {
        if (item.path && !item.isActive) {
            navigate(item.path);
        }
    };

    return (
        <nav className={[styles.nav, classes.nav, className].filter(Boolean).join(" ")} aria-label="Breadcrumb">
            <ol className={styles.list}>
                {items.map((item, index) => (
                    <li key={index} className={styles.item}>
                        {index > 0 && (
                            <ArrowRightIcon
                                className={[styles.separator, classes.separator].filter(Boolean).join(" ")}
                                aria-hidden="true"
                            />
                        )}
                        {item.isActive || !item.path ? (
                            <Typography
                                variant="body2"
                                className={[styles.active, classes.active].filter(Boolean).join(" ")}
                                aria-current="page"
                            >
                                {item.label}
                            </Typography>
                        ) : (
                            <button
                                type="button"
                                className={[styles.link, classes.link].filter(Boolean).join(" ")}
                                onClick={() => handleItemClick(item)}
                                aria-label={t("navigateTo", { page: item.label })}
                            >
                                <Typography
                                    variant="body2"
                                    className={[styles.text, classes.text].filter(Boolean).join(" ")}
                                >
                                    {item.label}
                                </Typography>
                            </button>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
